var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 53.998,
    viewBox: "0 0 85 53.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.295,
    y1: 0.74,
    x2: 1.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd4081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523e83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(-719 -542.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exclamation-circle",
    transform: "translate(750.492 564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-search-5617377_1_",
    "data-name": "noun-search-5617377 (1)",
    d: "M70.195,67.549l-2.676,2.676c-.023.023-.042.047-.063.07l-2.787-2.787A22.326,22.326,0,0,0,67.478,64.7l2.787,2.787c-.023.022-.048.041-.07.063Zm2.494.8a1.2,1.2,0,0,0-1.7,0L68.315,71.02a1.2,1.2,0,0,0,0,1.7l9.85,9.85a3.093,3.093,0,0,0,4.374-4.374l-9.85-9.85ZM50.476,71.539A21.033,21.033,0,1,1,71.509,50.505,21.057,21.057,0,0,1,50.476,71.539ZM67.537,50.506a17.061,17.061,0,1,0-17.061,17.06,17.081,17.081,0,0,0,17.061-17.06Z",
    transform: "translate(-52.935 -51.399)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 47,
    height: 4,
    rx: 2,
    transform: "translate(719 592)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 16,
    height: 4,
    rx: 2,
    transform: "translate(788 592)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.1014b8477f336077166eb1eb6b4497d5.svg";
export { ForwardRef as ReactComponent };